import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup } from '@mui/material';
import React from 'react';
import { useSessao } from '../redux/sessao/sessaoHooks';
import { COR_PRINCIPAL_DEFAULT } from '../constants';

interface Props {
  label: string;
  options: { label: string; value: string }[];
  value: string;
  onChange: (value: string) => void;
  name?: string;
  direction?: 'row' | 'column';
  disabled?: boolean;
}

const EdRadio: React.FC<Props> = (props) => {
  const { label, name, options, value, onChange, direction, disabled } = props;

  const [sessao] = useSessao();
  const corPrincipal = sessao?.empresa?.corPrincipal || COR_PRINCIPAL_DEFAULT;

  return (
    <FormControl component="fieldset" disabled={disabled}>
      <FormLabel component="legend" style={{ marginBottom: '5px' }}>
        {label}
      </FormLabel>
      <RadioGroup
        aria-label={name ? name : label}
        name={name ? name : label}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        row={direction === 'row'}
      >
        {options.map((option) => (
          <FormControlLabel
            key={option.value}
            value={option.value}
            control={<Radio style={{ color: corPrincipal }} size="small" />}
            label={option.label}
          />
        ))}
      </RadioGroup>
    </FormControl>
  );
};

export default EdRadio;
